<div class="flex flex-row items-center justify-between px-10 bg-white border border-zen-paleWhite h-fit min-h-16 py-5">
  <div class="flex flex-col gap-2">
    <ng-content select="[left]"></ng-content>
  </div>

  @if (display == HeaderRoutesDisplay.Expanded) {
  <div class="flex flex-row items-center justify-center gap-4">
    <ng-container *ngIf="routes?.length">
      <ng-container *ngFor="let route of routes; let i=index">
        <a [routerLink]="returnUrl(i)" class="flex flex-row items-center gap-2 cursor-pointer"
          [ngClass]="{'text-exp':i < activeIndex,'text-zen-primaryDark font-medium':i == activeIndex,'text-zen-primaryLight':i > activeIndex,}">
          <i *ngIf="i < activeIndex"
            class="text-2xl leading-6 flex items-center fa-check-circle fa-solid text-exp w-fit"></i>
          <div *ngIf="(i > activeIndex) || i == activeIndex"
            [ngClass]="i == activeIndex?'text-white bg-zen-primaryDark':'border border-zen-primaryLight text-zen-primaryLight'"
            class=" flex flex-row items-center justify-center  font-medium rounded-full maxmin6 leading-5 text-xs">
            <span>{{i +1}}</span>
          </div>
          <div class="flex flex-row items-center gap-1 overflow-hidden">
            <h5 class="text-xs leading-6 whitespace-nowrap ">
              {{route.name | translate:language:ModuleNames.Circle}}
            </h5>
          </div>
        </a>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="tabs?.length">
      <ng-container *ngFor="let tab of tabs; let i=index">
        <a (click)="(i!==0 && !tabs[i-1].disabled) ? tabChange.emit(i) :null"
          class="flex flex-row items-center gap-2 cursor-pointer"
          [ngClass]="{'text-exp':!tab.isActive && i < activeTab,'text-zen-primaryDark font-medium':tab.isActive,'text-zen-primaryLight':!tab.isActive && i > activeTab,}">
          <i *ngIf="!tab.isActive && i < activeTab"
            class="text-2xl leading-6 flex items-center fa-check-circle fa-solid text-exp w-fit"></i>

          <div *ngIf="(!tab.isActive && i > activeTab) || tab.isActive"
            [ngClass]="tab.isActive?'text-white bg-zen-primaryDark':'border border-zen-primaryLight text-zen-primaryLight'"
            class="flex flex-row items-center justify-center  font-medium rounded-full maxmin6 leading-5 text-xs">
            <span>{{i +1}}</span>
          </div>
          <div class="flex flex-row items-center gap-1 overflow-hidden">
            <h5 class="text-xs leading-6 whitespace-nowrap ">
              {{tab.name}}
            </h5>
          </div>
        </a>
      </ng-container>
    </ng-container>
  </div>
  }

  <div class="flex flex-row items-center justify-center">
    @if (display == HeaderRoutesDisplay.Condensed) {
    <div class="flex flex-row items-center justify-center gap-4">
      <ng-container *ngIf="routes?.length">
        <ng-container *ngFor="let route of routes; let i=index">
          <a [routerLink]="returnUrl(i)" class="flex flex-row items-center gap-2 cursor-pointer">
            <i *ngIf=" i < activeIndex"
              class="text-xl leading-5 flex items-center fa-check-circle fa-solid text-zen-green"></i>
            <div *ngIf="(i > activeIndex) || i == activeIndex"
              [ngClass]="i == activeIndex?'text-white bg-zen-primaryDark':'border border-zen-primaryLight text-zen-primaryLight'"
              class=" flex flex-row items-center justify-center  font-medium rounded-full maxmin5 leading-5 text-xs">
              <span>{{i +1}}</span>
            </div>
            <div [@routeAnimation] *ngIf="i == activeIndex" class="flex flex-row items-center gap-1 overflow-hidden">
              <h5 class="text-sm leading-6 text-zen-primaryDark font-medium whitespace-nowrap ">
                {{route.name | translate:language:ModuleNames.Circle}}
              </h5>
            </div>
          </a>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="tabs?.length">
        <ng-container *ngFor="let tab of tabs; let i=index">
          <a (click)="(i!==0 && !tabs[i-1].disabled) ? tabChange.emit(i) :null"
            class="flex flex-row items-center gap-2 cursor-pointer">

            <i *ngIf="!tab.isActive && i < activeTab"
              class="text-xl leading-5 flex items-center fa-check-circle fa-solid text-zen-green"></i>

            <div *ngIf="(!tab.isActive && i > activeTab) || tab.isActive"
              [ngClass]="tab.isActive?'text-white bg-zen-primaryDark':'border border-zen-primaryLight text-zen-primaryLight'"
              class=" flex flex-row items-center justify-center  font-medium rounded-full maxmin5 leading-5 text-xs">
              <span>{{i +1}}</span>
            </div>
            <div [@routeAnimation] *ngIf="tab.isActive" class="flex flex-row items-center gap-1 overflow-hidden">
              <h5 class="text-sm leading-6 text-zen-primaryDark font-medium whitespace-nowrap ">
                {{tab.name}}
              </h5>
            </div>
          </a>
        </ng-container>
      </ng-container>
    </div>
    }
  </div>

</div>
<!-- <a  [routerLink]="route.link" routerLinkActive #link="routerLinkActive" class="flex flex-row p-2 gap-1.5 cursor-pointer">
  <i class="text-xl leading-5 flex items-center" [ngClass]=" [ ((step.valid && selectedTab != step.tab)? 'fa-check-circle' : 'fa-circle-'+ (i+1) ), (selectedTab === step.tab ? 'fa-solid text-zen-text-zen-primaryDark' :step.valid ?'fa-solid text-zen-green': 'fa-regular text-zen-primaryLight') ]"></i>
  <h5 *ngIf="selectedTab==step.tab" class="text-sm leading-6 text-zen-primaryDark font-medium">
      {{step.name}}
  </h5>
</a> -->